import React, { ReactNode } from 'react';
import { Colors } from '.';
import { Copy, Flexer } from '../app/dashboard/elements/LayoutElements';
import { Icon } from '../concepts/resources/Icon';

const iconMap = {
    'exclamation': 'deqo://icons/hero/exclamation-circle',
    'question-mark': 'deqo://icons/hero/question-mark-circle',
    'upgrade': 'deqo://icons/i8/diamond',
};

const colorMap = {
    'blue': Colors.blue50,
    'red': Colors.red50,
    'green': Colors.green50,
    'purple': Colors.purple50,
} as const;

type NoticeProps =
    {
        icon: keyof typeof iconMap,
        color?: keyof typeof colorMap,
    } &
    (
        { text: string, children?: never } |
        { text?: never, children: ReactNode }
    );

export const Notice = React.memo<NoticeProps>(({ icon, text, children, color = 'blue' }) => {
    return <Flexer padding=".5 .5" gap=".5" flex="row" align="center" justify="center" background={colorMap[color]} borderRadius=".5">
        <Flexer width="1.5">
            <Icon src={iconMap[icon]} size="1.5" color={Colors.text} />
        </Flexer>
        <Copy flush size=".875" color={Colors.text}>{text || children}</Copy>
    </Flexer>;
});
